export const isDirectSalesCampaignCloned = (dealId?: string): boolean => {
  return dealId?.toLowerCase().startsWith('clone-') ?? false;
};
